import { Injectable } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { SpinnerComponent} from './spinner.component';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  constructor(  private dialog: MatDialog,) { 
  }

  show(): any {

    let show_ref = this.dialog.open(SpinnerComponent, {
      panelClass: 'spinner-dialog-container',
      data: null,
      hasBackdrop: true,
      disableClose: true
    });

    return show_ref

  }
  
}
